import React from "react";
import "./FullscreenImage.css";

const FullscreenImage = () => {
  return (
    <div className="fullscreen-image">
      <img src="/img/email/cover.png" alt="Cover" />
    </div>
  );
};

export default FullscreenImage;
